import { FC } from "react";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./ReviewsBadge.module.scss";
import useTranslationHook from "hooks/useTranslationHook";

interface ReviewsBadgeProps {
  rating: number;
  ratingLabel: string;
  reviewCount: number;
  onPress: () => void;
}

const ReviewsBadge: FC<ReviewsBadgeProps> = ({ rating, ratingLabel, reviewCount, onPress }) => {
  const { t } = useTranslationHook();

  if (!rating || rating <= 0) return null;

  return (
    <button
      type="button"
      className={styles.container}
      onClick={onPress}
      aria-label={`${rating.toFixed(1)} out of 5, ${ratingLabel}, ${reviewCount} Reviews`}
    >
      <div className={styles.scoreBadge}>
        <span className={styles.scoreNumber}>{rating.toFixed(1)}</span>
        <span className={styles.scoreMax}>/5</span>
      </div>
      <div className={styles.scoreInfo}>
        <span className={styles.ratingLabel}>{t(ratingLabel)}</span>
        <span className={styles.reviewCount}>
          ({reviewCount} {t("propertypage.reviews.title")})
        </span>
      </div>
      <svg className={styles.chevron} width="20" height="20" viewBox="0 0 16 16" fill="none">
        <path
          d="M6 4L10 8L6 12"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default wrapperHOC(ReviewsBadge, {
  componentName: "ReviewsBadge-PropertyPage",
  showForChina: true,
});
